import React from "react";

function AllInOne(props) {
  return (
    <div className="flex flex-col items-center justify-center w-full sm:w-11/12 md:w-10/12 lg:w-10/12 xl:w-9/12 mx-auto px-4 mt-8 mb-12">
      {/* Background decorative elements */}
      <div className="relative w-full">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-0 -left-32 w-64 h-64 bg-[#10c9c0]/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 -right-32 w-64 h-64 bg-[#10c9c0]/10 rounded-full blur-3xl"></div>
        </div>
        
        {/* Main content */}
        <div className="relative bg-white/80 backdrop-blur-md rounded-3xl shadow-xl border border-gray-200/50 p-8 lg:p-12">
          <div className="text-center space-y-6">
            {/* Property badge */}
            <div className="inline-flex items-center px-4 py-2 bg-[#10c9c0] text-white rounded-full text-sm font-semibold shadow-lg">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h3M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              Premium Property
            </div>
            
            {/* Property name with gradient text */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black bg-gradient-to-r from-gray-900 via-gray-700 to-gray-900 bg-clip-text text-transparent leading-tight">
              {props.property.propertyName}
            </h1>
            
            {/* Subtitle */}
            <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Experience luxury and comfort in this exceptional property
            </p>
            
            {/* Decorative divider */}
            <div className="flex items-center justify-center space-x-4 mt-8">
              <div className="w-12 h-0.5 bg-gradient-to-r from-transparent to-[#10c9c0]"></div>
              <div className="w-3 h-3 bg-[#10c9c0] rounded-full"></div>
              <div className="w-12 h-0.5 bg-gradient-to-l from-transparent to-[#10c9c0]"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllInOne;
